export class ApiCalls {
  private static instance: ApiCalls;

  private controller: AbortController | undefined = undefined;

  // eslint-disable-next-line no-useless-constructor,no-empty-function
  private constructor() {}

  static getInstance(): ApiCalls {
    if (!ApiCalls.instance) {
      ApiCalls.instance = new ApiCalls();
    }

    return ApiCalls.instance;
  }

  public createConnection() {
    if (!this.controller) {
      this.controller = new AbortController();
    }

    return this.controller;
  }

  public abortControllers() {
    this.controller?.abort();
    this.controller = undefined;
  }
}
